import React from 'react'
import './navbar.component.css';
import { Link, NavLink } from 'react-router-dom';

export default function Navbar() {
  return (
    
  <nav className="navbar navbar-expand-md navbar-dark nav-body">
  <div className="container-fluid">
    <Link to='/' className='navbar-brand'>ND</Link>
    
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li >
        <NavLink to='/' className={({isActive})=> isActive ? 'nav-link active-nav-link' : 'nav-link'}>Home</NavLink>
         </li>
        <li>
          <NavLink to='/projects' className={({isActive})=> isActive ? 'nav-link active-nav-link' : 'nav-link'}>Projects</NavLink>
        </li>

      </ul>

    </div>
  </div>
</nav>
    
  )
}
